import React, { useEffect, useRef, useState } from "react";
import styles from "./Topbar.module.scss";
import Icon from "../../ui/Icon/Icon";
// import LanguageSwitcher from "components/ui/LanguageSwitcher/LanguageSwitcher";
import { useAuth } from "context/AuthContext";
import { useI18n } from "context/I18nContext";

type TopbarProps = {
  onToggleSidebar: () => void;
  sidebarVisible: boolean;
};

function Topbar({ onToggleSidebar, sidebarVisible }: TopbarProps) {
  const { logout, user } = useAuth();
  const { t } = useI18n();
  const displayName =
    [user?.name, user?.surname].filter((part) => part?.trim()).join(" ") ||
    user?.userName ||
    "";
  const primaryRole = user?.roles?.find((role) => role.roleName?.trim())?.roleName ?? null;
  const roleLabel = primaryRole || "—";

  const [accountMenuOpen, setAccountMenuOpen] = useState(false);
  const accountMenuRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (
        accountMenuRef.current &&
        !accountMenuRef.current.contains(event.target as Node)
      ) {
        setAccountMenuOpen(false);
      }
    };

    if (accountMenuOpen) {
      document.addEventListener("mousedown", handleClick);
    }
    return () => document.removeEventListener("mousedown", handleClick);
  }, [accountMenuOpen]);

  return (
    <header className={styles.topbar}>
      <button
        type="button"
        className={styles.menu}
        aria-label={sidebarVisible ? "Hide sidebar" : "Show sidebar"}
        aria-pressed={sidebarVisible}
        onClick={onToggleSidebar}
      >
        <Icon name="pane" className={styles.menuIcon} fontSize="large" />
      </button>
      <div className={styles.space} />
      {/* <LanguageSwitcher variant="inline" /> Language switcher disabled while English-only */}

      <div className={styles.userMenu} ref={accountMenuRef}>
        <button
          type="button"
          className={styles.userTrigger}
          onClick={() => setAccountMenuOpen((prev) => !prev)}
          aria-haspopup="menu"
          aria-expanded={accountMenuOpen}
        >
          <div className={styles.avatar}>
            <Icon name="user" />
          </div>
          <div className={styles.meta}>
            <span className={styles.username}>{displayName}</span>
            <span className={styles.roleLabel}>{roleLabel}</span>
          </div>
        </button>
        {accountMenuOpen && (
          <div className={styles.dropdown} role="menu">
            <button
              type="button"
              className={styles.dropdownItem}
              onClick={() => {
                setAccountMenuOpen(false);
                logout();
              }}
            >
              {t("topbar.logout")}
            </button>
          </div>
        )}
      </div>
    </header>
  );
}

export default Topbar;
